// @flow
import * as React from 'react';
import styled from 'styled-components';
import Image from 'components/Image';
import {LocalizedBackgroundImage} from 'components/LocalizedImage';
import LocalizedImage from 'components/LocalizedImage';

import {
  DivTop,
  DivBottom,
  LayoutCenterMiddle,
  LayoutCenterBottom,
  LayoutTop,
  LayoutRightMiddle,
  LayoutRightBottom,
  LayoutWrapper,
  useLayoutState,
} from 'components/Layout';
import {
  LocalizedDiv,
  LocalizedParagraph,
  LocalizedParagraphFormat,
  useLocalized,
  //LocalizedLinkButton,
  Paragraph
} from 'components/Localized';
import {IsMobileAgent, IsDesktopAgent} from 'components/Responsive'
import GuideMessageCenter from 'components/GuideMessageCenter';
import * as VRUtils from 'utils/vrUtils';
import {TimeNumbers, TimeNumberDot} from './TimeNumbers.js'
import SlashImage from 'assets/images/driving-zone/img-time-s-slash.svg';
//import {useExteriorColorIndex} from 'components/Session';
import {Disclaimer, DisclaimerPopupButton} from 'components/Disclaimer';
import ButtonNextPage from 'components/ButtonNextPage';
import Space from 'components/Space';
import * as AudioUtils from 'utils/audioUtils';

type Props = {
  completed?: boolean,
  onStart: () => void,
  onStop: (number) => void,
  onRetry: () => void,
  onSaveImage?: () => void,
  onNext: () => void,
  imageCaptured: boolean,
  showDisclaimer?: (key:string)=> void
};

const displayTimeRatio = 3.501 / 3.10;

export default function DrivingZeroback(props: Props): React.Element<any> {
  const timeRecord = React.useRef(0)
  const [showGuide, setShowGuide] = React.useState(true);
  const [started, setStarted] = React.useState(false);
  const showGuidePrevious = React.useRef(true);

  console.log("DrivingZeroback: showGuide=",showGuide, ",started=", started);

  const handlePrepare = React.useCallback(() => {

    setShowGuide(false);
    console.log("DrivingZeroback: showGuidePrevious.current=",showGuidePrevious.current, ",showGuide=", showGuide);
    if (showGuidePrevious.current !== false ) {

      VRUtils.setAverageFPS(false);
      VRUtils.waitVREventListener("prepareRace", ()=>{
        VRUtils.fireVREvent('prepareRace');
        console.log("DrivingZeroback: call prepareRace");
      });
      showGuidePrevious.current = false;
    }
    
  }, [showGuide])

  const handleStartStop = React.useCallback(() => {
    const nextState = !started;
    setStarted(nextState);
    //console.log("acceleration:handleStartStop:", nextState);
    if (nextState) {
      window.tagManager.accelerationOfGTStartLinkClick();
      AudioUtils.play_motorZ100();
      props.onStart();
      VRUtils.setAverageFPS(true);
    }
    else {
      window.tagManager.accelerationOfGTShotLinkClick();
      AudioUtils.play_camera();
      const rangeFixMin = 310;
      const rangeFixMax = 319;

      VRUtils.fireVREvent("pauseTimer");
      console.log('zero-100', timeRecord.current);
      if (timeRecord.current >= rangeFixMin && timeRecord.current <= rangeFixMax) {
        timeRecord.current = 310;
        console.log("handleStartStop, set timeRecord.current to:", timeRecord.current);
        window.devCourseA2TimeRecordCurrent = "perfect "+timeRecord.current;
      } else {
        window.devCourseA2TimeRecordCurrent = timeRecord.current;
      }

      props.onStop(timeRecord.current);
    }
    
  }, [started, props]);

  const handleTime = React.useCallback((time: number) => {

    timeRecord.current = time;
    if (time >= 700) {
      setStarted(false);

      //props.onStop(timeRecord.current);
    }
   }, []);

  const handleRetry = React.useCallback(() => {
    handleTime(0);
    window.dragRaceTime = 0;
    setStarted(false);
    props.onRetry();
    window.tagManager.drivingZoneCourseAAccelerationTryAgainEvent();
   }, [props, handleTime]);

  return (
    <LayoutWrapper>
      {props.completed === undefined && <Zeroback showGuide={showGuide} time={timeRecord.current} started={started} imageCaptured={props.imageCaptured} onStartStop={handleStartStop} onTime={handleTime} />}
      {props.completed === true && <ZerobackCompleted showDisclaimer={props.showDisclaimer} time={timeRecord.current} imageCaptured={props.imageCaptured} onRetry={handleRetry} onSaveImage={props.onSaveImage} onNext={props.onNext}/>}
      {props.completed === false && <ZerobackTryAgain time={timeRecord.current} imageCaptured={props.imageCaptured} onRetry={handleRetry} onNext={props.onNext} />}
      {showGuide && <ZerobackGuide onNext={handlePrepare} />}
    </LayoutWrapper>
  );
}

type PropsGuide = {
  onNext: () => void,
};

function ZerobackGuide(props: PropsGuide): React.Element<any> {
  const index = React.useRef(-1);
  const [page, setPage] = React.useState(index.current);
  const localized = useLocalized();
  const timer = React.useRef(null);
  const [disclaimerOpened, setDisclaimerOpened] = React.useState(0);
  console.log("ZerobackGuide: page=", page, "index=", index);
  const onNext = props.onNext;

  const handleNext = React.useCallback(() => {
    //console.log("ZerobackGuide:, disclaimerOpened=", disclaimerOpened);
    if (disclaimerOpened !== 0) {
      index.current += 1;
      setPage(index.current);

      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }

      return;
    }
    if (index.current === 2) {
      onNext();
      return;
    }

    index.current += 1;
    setPage(index.current);

    if (timer.current) {
      clearTimeout(timer.current);
      timer.current = null;
    }

    VRUtils.waitVREventListener("prepareRace", ()=>{

      let waitDuration = 2000;
      if (index.current === 2) {
        waitDuration = 300;
      } else if (index.current === 0) {
        waitDuration = 3000;
      }

      timer.current = setTimeout(() => {
        console.log("ZerobackGuide: timer leads to call handleNext, index.current=", index.current);
        handleNext();
      }, waitDuration);
    });
    
  }, [onNext, disclaimerOpened]);

  React.useEffect(() => {
    handleNext();
    return() => {
      if (timer.current) {
        clearTimeout(timer.current);
        timer.current = null;
      }
    }
  }, [handleNext])

  return <GuideBack>
    <button onClick={handleNext}>
      <GuideMessageCenter show={page === 0}>
        <LocalizedParagraph {...localized.driving_a01_zeroback_014} />
        <LocalizedParagraph {...localized.driving_a01_zeroback_015} />
      </GuideMessageCenter>
      <GuideMessageCenterButton show={page === 1} onClick={
          (e)=>{
            console.log("DrivingZeroback disclaimer button: e=", e, "e.target.textContent=", e.target.textContent );
            if (localized.driving_a01_zeroback_012.datatext && localized.driving_a01_zeroback_012.datatext.indexOf("ⓘ") >= 0 && e.target !== null && e.target.textContent !== null && 
              e.target.textContent.indexOf("ⓘ") >= 0 && e.target.nodeName === "P" ) {
              setDisclaimerOpened(1);
            }
          }
      }>
        <LocalizedParagraph {...localized.driving_a01_zeroback_011} />
        <LocalizedParagraphFormat format={localized.driving_a01_zeroback_012} args={[localized.driving_a01_zeroback_012_a1, localized.driving_a01_zeroback_012_a2]} />
      </GuideMessageCenterButton>
    </button>
    { disclaimerOpened === 1 && 
    <Disclaimer popupTextKey="disclaimer_acceleration2_popup" onPopupClose={()=>{
      setDisclaimerOpened(0);
      if (index.current >= 3) {
        props.onNext();
        return;
      }

    }} />
    }

  </GuideBack>
}

type PropsZeroback = {
  showGuide: boolean,
  started: boolean,
  onStartStop: () => void,
  onTime: (number) => void,
  imageCaptured: boolean,
  time? : number
};

function syncCaptureCameraPlacement(nodeRefDOM : HTMLElement | null, force? : boolean) {

  VRUtils.ready(()=>{

    if (nodeRefDOM != null) {

      //console.log("syncCaptureCameraPlacement(1):", frameWidth, frameHeight, imageCaptured);
      const rect = nodeRefDOM.getBoundingClientRect();
      const x = rect.left / (document.body?.offsetWidth ?? 1);
      const y = rect.top / (document.body?.offsetHeight ?? 1);
      const w = rect.width / (document.body?.offsetWidth ?? 1);
      const h = rect.height / (document.body?.offsetHeight ?? 1);

      const x1 = x + w;
      const y1 = y + h;

      const vrCanvas = VRUtils.getVRCanvas();
      const extraWidth = Math.floor((vrCanvas?.offsetWidth ?? 1) * w);
      const extraHeight = Math.floor((vrCanvas?.offsetHeight ?? 1) * h);
      const extraCanvas = document.getElementById("extraCanvas");
      if (window.captureCameraPlacement != null && force === true) {
        window.captureCameraPlacement.eventSent = null;
      }
      if (window.captureCameraPlacement == null) {
        window.captureCameraPlacement = {x:x, y:y, x1:x1, y1:y1};
      }
      else if (window.captureCameraPlacement.x === x && 
        window.captureCameraPlacement.y === y && 
        window.captureCameraPlacement.x1 === x1 && 
        window.captureCameraPlacement.y1 === y1 && 
        window.captureCameraPlacement.eventSent) {
        return;
      }

      //console.log("re-create canvas:", x, y, x1, y1, newWidth, newHeight);
      window.captureCameraPlacement.x = x;
      window.captureCameraPlacement.y = y;
      window.captureCameraPlacement.x1 = x1;
      window.captureCameraPlacement.y1 = y1;

      if (extraCanvas?.dataset) {
        extraCanvas.dataset.srcX = x.toString();
        extraCanvas.dataset.srcY = y.toString();
        extraCanvas.dataset.width = extraWidth.toString();
        extraCanvas.dataset.height = extraHeight.toString();
      }

      if (extraCanvas?.style) {
        extraCanvas.style.left = rect.left + "px";
        extraCanvas.style.top = rect.top + "px";
        extraCanvas.style.width = extraWidth + "px";
        extraCanvas.style.height = extraHeight + "px";
      }

      if (VRUtils.hasVREventListener("cameraFrame")) {
        window.captureCameraPlacement.eventSent = true;
        //console.warn("sent cameraFrame");
        VRUtils.fireVREvent("cameraFrame", x, y, x1, y1);
      } else {
        window.captureCameraPlacement.eventSent = false;
      }
      
    } else {
      if (VRUtils.hasVREventListener("cameraFrame")) {
        //console.warn("sent cameraFrame null");
        //VRUtils.fireVREvent("cameraFrame", null);
        if (window.captureCameraPlacement != null) {
          window.captureCameraPlacement.eventSent = true;
        }
        
      } else {
        if (window.captureCameraPlacement != null) {
          window.captureCameraPlacement.eventSent = false;
        }
        
      }
    }
  });
  

}

function useSyncCameraPlacementEffect(nodeRefDOM : HTMLElement | null, frameWidth, frameHeight, recreateImage) {
  React.useEffect(() => {
    //console.log("In useSyncCameraPlacementEffect");


    syncCaptureCameraPlacement(nodeRefDOM);

    function forceSyncCaptureCameraPlacement() {
      setTimeout(function(){
        syncCaptureCameraPlacement(nodeRefDOM, true);
      }, 500);
    }

    VRUtils.addVREventListener("race2:intro1Completed", forceSyncCaptureCameraPlacement);


    function callSyncCaptureCameraPlacement() {
      syncCaptureCameraPlacement(nodeRefDOM);
      setTimeout(()=>syncCaptureCameraPlacement(nodeRefDOM), 500);
      setTimeout(()=>syncCaptureCameraPlacement(nodeRefDOM), 1000);
    }

    if (window.syncCaptureCameraPlacementTimer != null) {
      //console.log("clear syncCaptureCameraPlacementTimer");
      clearInterval(window.syncCaptureCameraPlacementTimer);
      window.syncCaptureCameraPlacementTimer = null;
      //window.addVREventListener("resize", )
    }
    window.syncCaptureCameraPlacementTimer = setInterval(()=>syncCaptureCameraPlacement(nodeRefDOM), 1000);
    window.addEventListener("resize", callSyncCaptureCameraPlacement);


    return () => {
      VRUtils.removeVREventListener("race2:intro1Completed", forceSyncCaptureCameraPlacement);
      window.removeEventListener("resize", callSyncCaptureCameraPlacement);
      if (window.syncCaptureCameraPlacementTimer != null) {
        clearInterval(window.syncCaptureCameraPlacementTimer);
        window.syncCaptureCameraPlacementTimer = null;
        //console.log("clear syncCaptureCameraPlacementTimer(1)");

      }
    }
  }, [nodeRefDOM, frameWidth, frameHeight]);
}

function Zeroback(props: PropsZeroback): React.Element<any> {
  const cornerImage = './driving-zone/img-zeroback-camera.png';
  const layoutState = useLayoutState();
  const carSpeed = React.useRef(0);
  const [carSpeedDeg, setCarSpeedDeg] = React.useState(-180);
  const timer = React.useRef(null);
  const frameWidth = React.useMemo(() => layoutState.mobile ? 377 * (layoutState.scale ?? 1) : 700 * (layoutState.scaleRaw ?? 1), [layoutState]);
  const frameHeight = React.useMemo(() => layoutState.mobile ? 210 * (layoutState.scale ?? 1) : 400 * (layoutState.scaleRaw ?? 1), [layoutState]);
  const {started} = props;
  const nodeRef = React.useRef(null);
  const imageCaptured = props.imageCaptured;

  const startedRef = React.useRef(null);

  React.useEffect(() => {
    startedRef.current = started;
    function log_car_speed(speed) {
      if (speed) {
        carSpeed.current = speed;
      }
    }
    //console.log("Zeroback, started:", started);
    function handleTime() {
      //console.log("handleTime:carSpeed=",carSpeed.current);
      if (startedRef.current) {
        const deg = (carSpeed.current * 0.01 * 128) - 180;

        //console.log("Zeroback, handleTime:deg=", deg);
        setCarSpeedDeg(deg);
      } else {

      }
      
    }

    if (started) {
      VRUtils.addVREventListener('car:speed', log_car_speed)
      timer.current = setInterval(handleTime, 1000 / 60);
      return;
    }

    return () => {
      VRUtils.removeVREventListener('car:speed', log_car_speed)
      if (timer.current) {
        clearInterval(timer.current)
        timer.current = null
      }
    }
  }, [started]);
  useSyncCameraPlacementEffect(nodeRef.current, frameWidth, frameHeight, true);
  //console.log("camera_frame(1):frameWidth:", frameWidth);
  const onStartStop = props.onStartStop;
  const handleStartStop = React.useCallback(() => {
      setTimeout(function(){syncCaptureCameraPlacement(nodeRef.current, true);}, 250);
      onStartStop();
  }, [onStartStop]);

  return (
    <React.Fragment>
      <TopGradient />
      <BottomGradient />
        <CameraFrameParent>
          <CameraFrame ref={nodeRef} dataWidth={frameWidth} dataHeight={frameHeight}>
            <CornerLT source={cornerImage} />
            <CornerRT source={cornerImage} />
            <CornerLB source={cornerImage} />
            <CornerRB source={cornerImage} />
          </CameraFrame>
        </CameraFrameParent>
      
      <CenterBottomGaugeWrapper>
        <TimeFrame source="./driving-zone/img-time-km.png" />
        <TimeGuage>
          <Image source="./driving-zone/img-time-gauge.png" style={{transform: `rotate(${carSpeedDeg}deg)`}} />
        </TimeGuage>
        <StopWatch time={props.time} mobile={layoutState.mobile} started={started} onTime={props.onTime}  />
      </CenterBottomGaugeWrapper>
      <IsMobileAgent>
        <LayoutRightMiddle>
          <StartButton onClick={handleStartStop} >
            {!imageCaptured && !started && <LocalizedImage key="start" source="./driving-zone/btn-zeroback-start.png" />}
            {!imageCaptured && started && <LocalizedImage key="stop" source="./driving-zone/btn-zeroback-stop.png" />}
          </StartButton>
        </LayoutRightMiddle>
      </IsMobileAgent>
      <IsDesktopAgent>
        <LayoutRightBottom>
          <StartButton onClick={handleStartStop}>
            {!imageCaptured && !started && <LocalizedImage key="start" source="./driving-zone/btn-zeroback-start.png" />}
            {!imageCaptured && started && <LocalizedImage key="stop" source="./driving-zone/btn-zeroback-stop.png" />}
          </StartButton>
        </LayoutRightBottom>
      </IsDesktopAgent>
      {!props.showGuide && !imageCaptured && !started &&
      <LayoutCenterMiddle>
        <Paragraph textKey="driving_a01_zeroback_013" textAlignCenter={true} />
      </LayoutCenterMiddle>
      }
    </React.Fragment>
  );
}

type PropsZerobackCompleted = {
  time: number,
  onRetry: () => void,
  onSaveImage?: () => void,
  onNext: () => void,
  
  imageCaptured: boolean,
  showDisclaimer?: (key:string)=> void
};

function ZerobackCompleted(props: PropsZerobackCompleted): React.Element<any> {
  const cornerImage = './driving-zone/img-zeroback-camera.png';
  const localized = useLocalized();
  const layoutState = useLayoutState();
  const frameWidth = React.useMemo(() => layoutState.mobile ? 377 * (layoutState.scale ?? 1) : 700 * (layoutState.scaleRaw ?? 1), [layoutState]);
  const frameHeight = React.useMemo(() => layoutState.mobile ? 210 * (layoutState.scale ?? 1) : 400 * (layoutState.scaleRaw ?? 1), [layoutState]);
  const nodeRef = React.useRef(null);
  //const colorCode = useExteriorColorIndex();
  // const carDownloadImages = layoutState.mobile ? [
  //   'acceleration-abp.jpg',
  //   'acceleration-swp.jpg',
  //   'acceleration-cr5.jpg',
  //   'acceleration-klm.jpg',
  //   'acceleration-du3.jpg',
  // ] : [
  //   'acceleration-abp-pc.jpg',
  //   'acceleration-swp-pc.jpg',
  //   'acceleration-cr5-pc.jpg',
  //   'acceleration-klm-pc.jpg',
  //   'acceleration-du3-pc.jpg',
  // ];

  useSyncCameraPlacementEffect(nodeRef.current, frameWidth, frameHeight, false);
  return (
    <React.Fragment>
      <DivFull>
        <CameraFrameOut />
        <CameraFrameWrapper>
          <CameraFrameOut2 />
          <CameraFrameOutline ref={nodeRef} dataWidth={frameWidth} dataHeight={frameHeight}>
            <CornerLT source={cornerImage} />
            <CornerRT source={cornerImage} />
            <CornerLB source={cornerImage} />
            <CornerRB source={cornerImage} />
          </CameraFrameOutline>
          <CameraFrameOut2 />
        </CameraFrameWrapper>
        <CameraFrameOut />
      </DivFull>
      <TitleWrapper>
        <TitleSpace />
        <LocalizedParagraph {...localized.driving_a01_zeroback_005} />
      </TitleWrapper>
      <ButtonNextPage buttons={[{onNext: props.onRetry, title:localized.driving_a01_zeroback_003, dataBackground:"#05141f", dataOutline:"#ffffff"}, {onNext: props.onNext, title: localized.driving_a01_zeroback_007}]}/>
      <RecordWrapper>
        <Paragraph textKey="driving_a06_zeroback_extra_001" />
        <DisclaimerPopupButton1 visible={true} onClick={()=>{
          if (props.showDisclaimer != null) {
            //console.log("DisclaimerPopupButton1 click");
            props.showDisclaimer("disclaimer_acceleration2_popup");
          } else {
            //console.log("DisclaimerPopupButton1 click, props.showDisclaimer=null");
          }
        }}  />
        <Space widthM={20} widthD={0} />
      </RecordWrapper>
    </React.Fragment>
  );
}

type PropsZerobackTryAgain = {
  time: number,
  onRetry: () => void,
  onNext: () => void,
};

function ZerobackTryAgain(props: PropsZerobackTryAgain): React.Element<any> {
  const cornerImage = './driving-zone/img-zeroback-camera.png';
  const localized = useLocalized();
  const layoutState = useLayoutState();
  const frameWidth = React.useMemo(() => layoutState.mobile ? 377 * (layoutState.scale ?? 1) : 700 * (layoutState.scaleRaw ?? 1), [layoutState]);
  const frameHeight = React.useMemo(() => layoutState.mobile ? 210 * (layoutState.scale ?? 1) : 400 * (layoutState.scaleRaw ?? 1), [layoutState]);
  const nodeRef = React.useRef(null);
  useSyncCameraPlacementEffect(nodeRef.current, frameWidth, frameHeight, false);
  return (
    <React.Fragment>
      <DivFull>
        <CameraFrameOut />
        <CameraFrameWrapper>
          <CameraFrameOut2 />
          <CameraFrameOutline ref={nodeRef} dataWidth={frameWidth} dataHeight={frameHeight}>
            <CornerLT source={cornerImage} />
            <CornerRT source={cornerImage} />
            <CornerLB source={cornerImage} />
            <CornerRB source={cornerImage} />
          </CameraFrameOutline>
          <CameraFrameOut2 />
        </CameraFrameWrapper>
        <CameraFrameOut />
      </DivFull>
      <TitleWrapper>
        <LocalizedParagraph {...localized.driving_a01_zeroback_001} />
        <LocalizedDiv {...localized.driving_a01_zeroback_002} />
      </TitleWrapper>
      <ButtonNextPage buttons={[{onNext: props.onRetry, title:localized.driving_a01_zeroback_003, dataBackground:"#05141f", dataOutline:"#ffffff"}, {onNext: props.onNext, title: localized.driving_a01_zeroback_004}]}/>
      <RecordWrapper>
        <TimeRecord time={props.time * displayTimeRatio} numberWidth={layoutState.mobile ? 18 : 30} numberHeight={layoutState.mobile ? 30 : 47} /> <img src={SlashImage} alt="" />{' '}
        <LocalizedParagraph {...localized.driving_a01_zeroback_008} />
      </RecordWrapper>
    </React.Fragment>
  );
}

type PropsStopWatch = {
  time?: number,
  started: boolean,
  mobile: boolean,
  onTime: (number: number) => void,
}

function StopWatch(props: PropsStopWatch): React.Element<any> {
  //console.log("StopWatch, started:", props.started);
  const [time, setTime] = React.useState(props.time || 0);
  //const startTime = React.useRef(new Date());
  const timer = React.useRef(null);

  //console.log("acceleration: StopWatch, time=", time);

  const handleTime = React.useCallback((value: number) => {
    props.onTime(value);
  }, [props]);

  const handleTimeRef = React.useRef(null);
  handleTimeRef.current = handleTime;

  React.useEffect(() => {
    //console.log("timerbug: useEffect, props.started=", props.started, "timer.current=", timer.current);
    function time() {

      //console.log("timerbug: window.dragRaceTime=", window.dragRaceTime);
      //const now = new Date();
      const elapsedTime = Math.floor(window.dragRaceTime * 100) || 0;//Math.floor((now.getTime() - startTime.current) * 0.1);
      let displayTime = elapsedTime;

      const rangeFixMin = 310;
      const rangeFixMax = 319;
      if (displayTime > rangeFixMin && displayTime <= rangeFixMax) {
        displayTime = 310;
        
      } else {

      }

      
      displayTime *= displayTimeRatio;
      window.devCourseA2StopWatchDisplayTime = displayTime;

      setTime(displayTime);

      if (handleTimeRef.current != null) {
        handleTimeRef.current(elapsedTime);
      }
      
    }
    if(props.started) {
      timer.current = setInterval(time, 1000/60);
      //startTime.current = new Date();
    } else {

    }
    return () => {
      //console.log("timerbug: clear timer.current=", timer.current);
      if (timer.current) {
        clearInterval(timer.current)
        timer.current = null
      }
    }
  }, [props.started])
  return <TimeRecord time={time} numberWidth={props.mobile ? 24 : 40} numberHeight={props.mobile ? 38 : 62} paddingBottom={props.mobile ? 14 : 36} />
}

type PropsTimeRecord = {
  time: number,
  paddingBottom?: number,
  numberWidth? : number,
  numberHeight? : number,
};

function TimeRecord(props: PropsTimeRecord): React.Element<any> {
  const {time = 0, paddingBottom = 0, ...others} = props;
  
  return (
    <NumberWrapper paddingBottom={paddingBottom}>
      <Number {...others} datavalue={Math.floor(time / 100) % 10} />
      <NumberDot {...others}>
        <img src={TimeNumberDot} alt="" />
      </NumberDot>
      <Number {...others} datavalue={Math.floor(time / 10) % 10} alt="" />
      <Number {...others} datavalue={Math.floor(time) % 10} alt="" />
    </NumberWrapper>
  );
}

function Number(props): React.Element<any> {
  const timeNumbers = TimeNumbers;

  return <NumberImage {...props}>{timeNumbers.map((value, index) => <img key={index} src={timeNumbers[index]} alt="" style={{visibility: props.datavalue === index ? 'visible' : 'hidden' }} />)}</NumberImage>
}

const StartButton = styled.button`
  width: ${props => props.theme.layout.mobile ? 90 : 140}px;
  height: ${props => props.theme.layout.mobile ? 90 : 140}px;
  margin-right: 40px;

  ${props => props.theme.layout.mobile === false &&
    `position: absolute;
    right: 160px;
    bottom: 44px;
    `
  }

  img {
    width: 100%;
    height: 100%;
  }
`;

const GuideMessageCenterButton = styled(GuideMessageCenter)`
  pointer-events: auto;
`;

const DisclaimerPopupButton1 = styled(DisclaimerPopupButton)`
  left: 3px;
`;

const TitleWrapper = styled(LayoutTop)`
  position: absolute;
  padding-top: ${props => props.theme.layout.mobile ? 31 : 85}px;
  left: 0px;
  top: 0px;
  text-align: center;
  p {
    padding-bottom: ${props => props.theme.layout.mobile ? 7 : 19}px;
  }
`;

const TitleSpace = styled.div`
  height: 14px;
`;

const DivFull = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

const CameraFrameParent = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  top:0px;
  left:0px;
`;

const CameraFrame = styled.div`
  width: ${(props) => props.dataWidth}px;
  height: ${(props) => props.dataHeight}px;

  position: relative;
`;

const CameraFrameOutline = styled.div`
  width: ${(props) => props.dataWidth}px;
  height: ${(props) => props.dataHeight}px;
  position: relative;
  border: 1px solid rgba(255, 255, 255, 0.1);
`;

const CameraFrameOut = styled.div`
  flex: 1;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

const CameraFrameOut2 = styled.div`
  flex: 1;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.5);
`;

const CameraFrameWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: auto;
  height: 100%;
`;

const Corner = styled(Image)`
  width: ${props => props.theme.layout.mobile ? 14: 20}px;
  height: ${props => props.theme.layout.mobile ? 15: 20}px;
`;

const CornerLT = styled(Corner)`
  position: absolute;
  left: 0px;
  top: 0px;
`;

const CornerRT = styled(Corner)`
  position: absolute;
  right: 0px;
  top: 0px;
  transform: scaleX(-1);
`;

const CornerLB = styled(Corner)`
  position: absolute;
  left: 0px;
  bottom: 0px;
  transform: scaleY(-1);
`;

const CornerRB = styled(Corner)`
  position: absolute;
  right: 0px;
  bottom: 0px;
  transform: rotate(180deg);
`;

const TopGradient = styled(DivTop)`
  width: 100%;
  height: 70px;
  background: linear-gradient(0deg, rgba(0, 0, 0, 0) 33.33%, rgba(0, 0, 0, 76) 100%);
`;

const BottomGradient = styled(DivBottom)`
  height: 110px;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0) 33.33%, rgba(0, 0, 0, 76) 100%);
`;
 
const TimeFrame = styled(LocalizedBackgroundImage)`
  width: ${props => props.theme.layout.mobile ? 239 : 384}px;
  height: ${props => props.theme.layout.mobile ? 107 : 170}px;
  position: absolute;
  left: calc((100% - ${props => props.theme.layout.mobile ? 216 : 344}px) * 0.5);
  bottom: ${props => props.theme.layout.mobile ? 4 : 20}px;
  background-size: 100% 100%;
`;

const TimeGuage = styled.div`
  width: ${props => props.theme.layout.mobile ? 180 : 290}px;
  height: ${props => props.theme.layout.mobile ? 91 : 146}px;
  position: absolute;
  left: calc((100% - ${props => props.theme.layout.mobile ? 180 : 290}px) * 0.5);
  bottom: ${props => props.theme.layout.mobile ? 4 : 20}px;
  clip-path: inset(0 0 0 0);
  img {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);
    transform-origin: center bottom;
  }
`;

const NumberWrapper = styled.div`
  height: ${props => props.theme.layout.mobile ? 38 - 4 : 47}px;
  padding-top: ${props => props.theme.layout.mobile ? 4 : 0}px;
  padding-bottom: ${(props) => props.paddingBottom}px;

  > * {
    &:last-child {
      margin-right: 0px;
    }
  }
`;

const NumberImage = styled.div`
  width: ${props => props.numberWidth ?? 24}px;
  height: ${props => props.numberHeight ?? 38}px;
  margin-right: 5px;
  display: inline-block;
  vertical-align:top;
  text-align: right;
  position: relative;

  > img {
    height: 100%;
    position: absolute;
    right: 0px;
    top: 0px;
  }
`;

const NumberDot = styled.div`
  height: 5px;
  display: inline-block;
  margin-right: 5px;
  vertical-align:bottom;

  img {
    width: 5px;
    height: 5px;
  }
`;

const CenterBottomGaugeWrapper = styled(LayoutCenterBottom)`
`;

const RecordWrapper = styled(LayoutCenterBottom)`
  position: absolute;
  padding-bottom: ${props => props.theme.layout.mobile ? 38 : 53}px;

  > img {
    width: ${props => props.theme.layout.mobile ? 9 : 14}px;
    height: ${props => props.theme.layout.mobile ? 20 : 32}px;
    padding-left: ${props => props.theme.layout.mobile ? 8 : 15}px;
    padding-right: ${props => props.theme.layout.mobile ? 8 : 13}px;
  }
`;

const GuideBack = styled(LayoutWrapper)`
  background-color: rgba(0, 0, 0, 0.6);
  pointer-events: auto;
  z-index: 1001;

  > button {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    > div {
      position: absolute;
    }
  } 
`;
